<script setup>
const props = defineProps({
  title: String,
  link: Object
})

const config = useRuntimeConfig()
const mnetSiteUrl = config.public.NUXT_APP_MNET_SITE_URL

function getSiteUrl (path) {
  if (/http|#/.test(path)){
    return path
  }
  return mnetSiteUrl + path
}
</script>

<template>
  <a :href="getSiteUrl(link.url)" :class="link.class || ''" :target="link.target || '_self'">{{ link.text }}</a>
</template>